import React from "react";
import { Box, Typography, Grid2, Collapse } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";
import WorkoutHistorySet from "../client-exercise-history/workout-history/WorkoutHistorySet";
import { ExerciseTypeExtra } from "../../constants";
import WorkoutCardBase from "./WorkoutCardBase";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(-1),
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colorSystem.gray4,
      borderRadius: 3,
    },
  },
  container: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  exerciseTitle: {
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: "bold",
    paddingLeft: theme.spacing(2),
    margin: theme.spacing(0, 0, 1),
  },
  divider: {
    width: "100%",
    height: 1,
    backgroundColor: colorSystem.gray5,
    marginTop: theme.spacing(1),
  },
  noResult: {
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: "bold",
    paddingLeft: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));
const workoutHistorySetStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    maxHeight: 42,
    gap: 20,
    alignItems: "center",
    borderRadius: 4,
    padding: theme.spacing(0.5, 2),
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  unitText: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  smallCircle: {
    width: 28,
    height: 28,
    fontSize: 12,
  },
}));

type ClientWorkoutsChooseProps = {
  onClose: () => void;
  selectWorkout: {
    title: string;
    date: string;
    session: number;
    min: number;
    value: any[];
  };
};

const ClientWorkoutsChoose = ({
  onClose,
  selectWorkout,
}: ClientWorkoutsChooseProps) => {
  const s = useStyles();
  const sWorkoutSet = workoutHistorySetStyles();
  const [open, setOpen] = React.useState(false);
  // set a slight delay to trigger the collapse animation
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <Box className={s.root}>
      {selectWorkout.session ? (
        <>
          <WorkoutCardBase
            title={selectWorkout.title}
            subtitle={`Recorded ${selectWorkout.date}`}
            footerItem={{
              session: selectWorkout.session,
              min: selectWorkout.min,
            }}
            onClick={onClose}
            onClose={onClose}
            type="close"
          />
          <Collapse in={open} timeout={400} unmountOnExit>
            <Box className={s.scrollContainer}>
              <Grid2 container spacing={2} className={s.container}>
                {selectWorkout.value.map((item, index) => (
                  <Grid2 key={index} size={{ xs: 12 }}>
                    <Typography className={s.exerciseTitle}>
                      {item.title}
                    </Typography>

                    {Array.isArray(item.result) &&
                      item.result.map((i, subIndex) => (
                        <WorkoutHistorySet
                          key={subIndex}
                          setNumber={subIndex}
                          set={i}
                          typeExtraMeasurement={
                            item?.typeExtraMeasurement || ExerciseTypeExtra.NONE
                          }
                          exerciseTypeSet={item.typeSet}
                          units={item.units}
                          classes={{
                            root: sWorkoutSet.body,
                            unitText: sWorkoutSet.unitText,
                          }}
                          circleClassName={sWorkoutSet.smallCircle}
                        />
                      ))}

                    {index !== selectWorkout.value.length - 1 && (
                      <Box className={s.divider} />
                    )}
                  </Grid2>
                ))}
              </Grid2>
            </Box>
          </Collapse>
        </>
      ) : (
        <Typography className={s.noResult}>No results</Typography>
      )}
    </Box>
  );
};
export default React.memo(ClientWorkoutsChoose);
